module.exports = __webpack_public_path__ + "static/img/alarm-icon.e0200e07.svg";